<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center">
        <router-link to="/">
          <v-img
            alt="Vuetify Logo"
            class="shrink mr-5"
            contain
            src="@/assets/national-retail-solutions-compressed.png"
            transition="scale-transition"
            width="140"
          />
        </router-link>
      </div>
      <v-toolbar-title v-if="currentRoute === 'nrshome'">Altria - Promotions dashboard</v-toolbar-title>
      <v-toolbar-title v-if="currentRoute === 'odareports'">Altria - ODA Reports</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-toolbar-items v-if="isLoggedIn && !Logged.nrs" class="menu-bar" :class="{'auto-login': Logged && Logged.from === 'autologin'}">

        <v-btn v-if="Duplicates.length > 0" text to="/" exact active-class="menu-is-active elevation-20">
          <v-icon small>fas fa-smoking</v-icon>
          <span class="pl-1">Altria promotions</span>
        </v-btn>

        <v-btn v-if="Duplicates.length > 0" text to="duplicates" exact active-class="menu-is-active elevation-20">
          <v-icon small>fas fa-exclamation-triangle</v-icon>
          <span class="pl-1">Existing promotions</span>
        </v-btn>

        <v-btn
          v-if="Logged && Logged.from === 'login'"
          text active-class="menu-is-active elevation-20" @click="exit()">
          <v-icon small>fas fa-sign-out-alt</v-icon>
          <span class="pl-1">Logoff</span>
        </v-btn>

      </v-toolbar-items>

      <v-toolbar-items v-if="isLoggedIn && Logged.nrs" class="menu-bar">

        <v-btn text to="nrshome" exact active-class="menu-is-active elevation-10">
          <v-icon small>fa-solid fa-store</v-icon>
          <span class="pl-1">Stores</span>
        </v-btn>

        <v-btn text to="odareports" exact active-class="menu-is-active elevation-10">
          <v-icon small>fa-solid fa-chart-line</v-icon>
          <span class="pl-1">ODA Reports</span>
        </v-btn>

        <!-- <v-btn
          text active-class="menu-is-active elevation-10" @click="exit()">
          <v-icon small>fas fa-sign-out-alt</v-icon>
          <span class="pl-1">Back to portal</span>
        </v-btn> -->

        </v-toolbar-items>

    </v-app-bar>

    <v-main>
          <transition name="fade" mode="out-in" appear>
            <router-view/>
          </transition>
    </v-main>

    <v-footer
        app
        color="primary"
        padless
    >
      <Footer/>
    </v-footer>

    <v-progress-circular
          id="progress"
          class="progress"
          :size="60"
          :width="5"
          indeterminate
          :color="progressColor"
    ></v-progress-circular>

  </v-app>
</template>
<style lang="scss" scoped>

  .menu-bar {
    .menu-is-active {
      background-color: purple;
    }
  }
  .auto-login {
    padding-right: 130px;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: ease;
  }
  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }

  .slide-enter-active,
  .slide-leave-active {
    transition-duration: 0.5s;
    transition-property: height, opacity, transform;
    transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
    overflow: hidden;
  }

  .slide-enter, .slide-leave-to {
    opacity: 0;
    transform: translate(30em, 0);
  }

</style>
<script>
import Footer from '@/components/Footer'
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  components: {
    Footer
  },
  mounted () {
    document.getElementById('loading-screen').style.display = 'none'
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'Logged', 'Duplicates', 'progressColor']),
    currentRoute() {
      return this.$route.name
    }
  },
  methods: {
    exit () {
      this.$router.push(`/login/${this.Logged.appattrs.store_id}`)
    }
  }
}
</script>
